/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniArrowPath = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-arrow-path ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M15.3125 11.4236C14.5263 14.3576 11.5104 16.0988 8.57636 15.3127C7.60734 15.053 6.7703 14.5514 6.11058 13.8904L5.79904 13.5789L8.23227 13.5785C8.64649 13.5784 8.98221 13.2425 8.98214 12.8283C8.98206 12.4141 8.64622 12.0784 8.232 12.0785L3.98857 12.0792C3.78965 12.0792 3.5989 12.1583 3.45827 12.299C3.31764 12.4397 3.23866 12.6305 3.23871 12.8294L3.2396 17.0712C3.23968 17.4854 3.57554 17.8211 3.98975 17.821C4.40397 17.821 4.73968 17.4851 4.7396 17.0709L4.73909 14.6403L5.04894 14.9501C5.88997 15.7926 6.95765 16.4318 8.18814 16.7615C11.9224 17.7621 15.7608 15.5461 16.7613 11.8118C16.8686 11.4117 16.6311 11.0005 16.231 10.8932C15.8309 10.786 15.4197 11.0235 15.3125 11.4236ZM16.5414 7.70119C16.682 7.56051 16.761 7.36971 16.761 7.17078L16.7603 2.92883C16.7602 2.51462 16.4244 2.17889 16.0102 2.17896C15.596 2.17902 15.2602 2.51487 15.2603 2.92908L15.2607 5.35995L14.9509 5.05013C14.1099 4.20771 13.042 3.56827 11.8116 3.23859C8.07734 2.238 4.23898 4.45407 3.23839 8.18834C3.13118 8.58844 3.36862 8.99969 3.76872 9.1069C4.16882 9.2141 4.58007 8.97667 4.68728 8.57657C5.47346 5.6425 8.48931 3.9013 11.4234 4.68748C12.3924 4.94714 13.2295 5.44881 13.8892 6.10979L14.2003 6.4209L11.7684 6.4209C11.3542 6.4209 11.0184 6.75669 11.0184 7.1709C11.0184 7.58512 11.3542 7.9209 11.7684 7.9209H16.011C16.2099 7.9209 16.4007 7.84187 16.5414 7.70119Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
    </svg>
  );
};
